module.exports = __webpack_public_path__ + "static/media/hoverup.82594475.svg";